<div *transloco="let t">
  <div class="event-card" [class.p-15]="currentLayout == CalendarViewType.LIST">
    <ng-template [ngTemplateOutlet]="currentLayout === CalendarViewType.LIST ? listItem : gridItem"/>
  </div>
  <!-- LIST ITEM -->
  <ng-template #listItem>
    <div class="d-flex gap-3">
      <div class="position-relative flex-shrink-0">
        <ng-template [ngTemplateOutlet]="leagueImage" [ngTemplateOutletContext]="{ cls: 'list' }"/>
      </div>

      <div class="d-flex flex-column flex-grow-1 min-width-0 justify-content-center">
        <div class="d-flex flex-column flex-md-row gap-0 gap-md-2 pb-2">
        <ng-template [ngTemplateOutlet]="statusTag"/>
        <ng-template [ngTemplateOutlet]="sportTag"/>
        </div>

        <div class="fw-500 pb-3">
          <ng-template [ngTemplateOutlet]="leagueName"/>
        </div>
        <div class="d-flex gap-1 align-items-center color-slate-600">
          <div class="d-flex align-items-center color-slate-600">
            <p class="text-truncate color-slate-600">
              <app-event-date-display [displayDay]="false" [start]="league?.start" [end]="league?.end" [showIcon]="false"/>
            </p>
          </div>
          <i class="bi bi-dot fs-20"></i>
          <div class="">
            <ng-template [ngTemplateOutlet]="eventCount"/>
          </div>
          <i class="bi bi-dot fs-20"></i>
          <div class="d-flex align-items-center">
              <ng-template [ngTemplateOutlet]="location" [ngTemplateOutletContext]="{ lsBrk: 4 }"/>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column flex-shrink-0 align-items-end justify-content-between">
        <div class="">
        </div>
        <div class="d-flex justify-content-end">
          <ng-template [ngTemplateOutlet]="actionButton"/>
        </div>
      </div>

    </div>
  </ng-template>

  <ng-template #gridItem>
    <div class="d-flex flex-column pb-3">

      <div class="position-relative flex-shrink-0">
        <ng-template [ngTemplateOutlet]="leagueImage" [ngTemplateOutletContext]="{ cls: 'grid' }"/>
      </div>


      <div class="d-flex flex-column flex-grow-1 min-width-0 px-12 pt-3">
        <div class="d-flex justify-content-start align-items center gap-2">
          <ng-template [ngTemplateOutlet]="statusTag"/>
          <ng-template [ngTemplateOutlet]="sportTag"/>
        </div>

        <div class="d-flex flex-column gap-1">
          <div class="event-name">
            <p class="fw-500">
              <ng-template [ngTemplateOutlet]="leagueName"/>
            </p>
          </div>
          <div class="fs-14 d-flex gap-1 color-slate-600 align-items-center">
            <div class="d-flex align-items-center color-slate-600 fs-14">
              <p class="text-truncate color-slate-600 fs-14">
                <app-event-date-display [displayDay]="false" [start]="league?.start" [end]="league?.end" [showIcon]="false"/>
              </p>
            </div>
            <i class="bi bi-dot fs-20"></i>
            <ng-template [ngTemplateOutlet]="eventCount"/>
            <i class="bi bi-dot fs-20"></i>
            <ng-template [ngTemplateOutlet]="location" [ngTemplateOutletContext]="{ lsBrk: 1 }"/>
          </div>

          <div class="mt-1">
            <ng-template [ngTemplateOutlet]="actionButton"/>
          </div>
        </div>
      </div>
    </div>
  </ng-template>



  <ng-template #leagueImage let-cls="cls">
      <img src="{{league?.imageMedium ||  ''}}"
           alt="league Image"
           class="bck-img {{cls}} {{league?.status === LeagueStatus.FINISHED ? 'faded' : ''}}"
           [sportOne]="league?.sportId"
           appImageFallback/>

    </ng-template>



  <ng-template #location let-lsBrk="lsBrk">
    <app-location-display [showIcon]="false" [countries]="league?.countries ?? []" [showList]="true" [listSizeBreakPoint]="lsBrk ?? undefined"/>
  </ng-template>


  <ng-template #leagueName>
    <div class="fs-17" [class.fs-18]="currentLayout == CalendarViewType.LIST">
      <app-language-output
              [hrLabel]="league?.name"
              [srLabel]="league?.nameSr"
              [enLabel]="league?.nameEng"
              [itLabel]="league?.nameIta"
              [bsLabel]="league?.nameBs"
              [siLabel]="league?.nameSlo"
              [defaultLanguage]="league?.defaultLanguage"
              [languages]="languages"/>
    </div>
  </ng-template>

  <ng-template #actionButton>
    <app-button-alt
            [buttonHeight]="'40px'"
            [text]="t('app.common.view.league')"
            [buttonColor]="'transparent'"
            [textColor]="'var(--teal-500)'"
            [isFullWidth]="currentLayout === CalendarViewType.GRID"
            (onClickCallback)="onRightButtonClick()"/>
  </ng-template>

  <ng-template #sportTag>
    @if (league?.sportId) {
    <div class="d-flex align-items-center mb-1">
      <div class="tag italic bolder">
      <p class="text-uppercase">{{ t("app.common.sports." + league!.sportId)}}</p>
       </div>
    </div>
    }
  </ng-template>

  <ng-template #statusTag>
    <div class="d-flex align-items-center pb-1">
      @if (league?.status != null) {
      <p class="tag uppercase bolder"
         [class.amber]="league?.status === LeagueStatus.INACTIVE"
         [class.green]="league?.status === LeagueStatus.ACTIVE"
         [class.dark-gray]="league?.status === LeagueStatus.FINISHED">
      {{ t("league.item.status." + league!.status) }}
      </p>
      }
    </div>
  </ng-template>

  <ng-template #eventCount>
    <div class="d-flex align-items-center">
      <span class="ms-1 text-truncate color-slate-600">
          {{ t('app.common.events.count.' +
              (league?.eventsCount! > 3 ? 'other' : league?.eventsCount),
              { count: league?.eventsCount }) }}
      </span>
    </div>
  </ng-template>

</div>
